module.exports = __webpack_public_path__ + "img/error_image.2b6f0534.svg";